// TSS vite/03 §"Query keys convention".
//
// The entity is `tasks`, not `findings`: these ARE tasks, and a second name
// for the same rows would make an invalidation from the task screens miss
// them — a finding promoted from there would keep showing as pending here.

export const findingKeys = {
    all:      ['tasks'],
    proposed: (params) => ['tasks', 'proposed', params],
    origin:   (id) => ['tasks', 'detail', id],
};
